import type { CardDefinition } from "../domain/types/index.js";

export const DISRUPTION_CARDS = {
  "work-triage": {
    id: "work-triage", name: "業務切り分け", type: "action", rewardTier: "medium",
    text: "1枚引く。行動+1。手札を最大1枚選び、このPJが終わるまで山札から除外する。選択は任意。除外した元のカードは終了時に戻る。",
    effect: { kind: "compound", effects: [
      { kind: "drawAction", draw: 1, actions: 1 },
      { kind: "caseExclude" },
    ] },
  },
  "unresolved-task": {
    id: "unresolved-task", name: "差し戻し対応", type: "task", caseOnly: true, rewardTier: "none",
    retainedFatigue: 1,
    text: "手札に残留し、プロジェクト未達成のラウンド終了時に疲労+1。施策として使用すると消滅（行動1を消費）。施策枚数や経営会議の対象には数えない。プロジェクト終了時にも消える。",
    effect: { kind: "resolveObstruction" },
  },
} as const satisfies Record<string, CardDefinition>;
